import React, {useEffect} from 'react'
import {UIGameVote} from './UIGameVote'
import {useUIContext} from '../../contexts/UIContext'
import {useUIGameVoteContext} from './UIGameVoteContext'

export interface UIGameVoteProps {
    className?: string
    setLogVisible?: (isVisible: boolean) => void
    setChatVisible?: (isVisible: boolean) => void
}

export const UIGameVoteContainer = ({className, setLogVisible, setChatVisible}: UIGameVoteProps) => {
    const {isUserOnMobile} = useUIContext()
    const {voteState, onAccept, onReject, isMyVotePending} = useUIGameVoteContext()

    useEffect(() => {
        if(voteState !== null) {
            setLogVisible?.(false)
            if(isUserOnMobile) setChatVisible?.(false)
        } else {
            setLogVisible?.(true)
            setChatVisible?.(true)
        }
    }, [voteState])

    if(voteState == null) return null

    return (
        <UIGameVote
            onAccept={onAccept}
            onReject={onReject}
            voteState={voteState}
            className={className}/>
    )
}
